<template>
  <div>
    <p class="part-title">网络条件要求
      <a
        v-show="isShow"
        href="javascript:;"
        @click="clearItem('net')"
      ><i class="icon iconfont">&#xe614;</i>清空</a>
      <a
        v-show="isShow"
        href="javascript:;"
        @click="openNet"
      ><i class="icon iconfont">&#xe660;</i>编辑</a>
    </p>
    <div class="part-content">
      <span class="content-title">说明客户端到服务器的带宽要求<span class="fangsong">（需提供测试带宽服务）</span>：</span>
      <div
        class="content-text"
        v-if="!formInfo.net_claim_content"
      >暂无内容</div>
      <div
        class="content-text"
        v-if="formInfo.net_claim_content"
        v-html="formInfo.net_claim_content"
      ></div>
      <div class="clearfix"></div>
      <span class="content-title">说明能够支持的同时在线人数<span class="fangsong">（需提供在线排队提示服务）</span>：</span>
      <div
        class="content-text"
        v-if="!formInfo.net_claim_count"
      >暂无内容</div>
      <div
        class="content-text"
        v-if="formInfo.net_claim_count"
        v-html="formInfo.net_claim_count"
      ></div>
    </div>
    <p class="part-title">用户操作系统要求（如Windows、Unix、iOS、Android等）
      <a
        v-show="isShow"
        href="javascript:;"
        @click="clearItem('sys')"
      ><i class="icon iconfont">&#xe614;</i>清空</a>
      <a
        v-show="isShow"
        href="javascript:;"
        @click="openSys"
      ><i class="icon iconfont">&#xe660;</i>编辑</a>
    </p>
    <div class="part-content"><span class="content-title">计算机操作系统和版本要求：</span>
      <div
        class="content-text"
        v-if="!formInfo.sys_claim_computer"
      >暂无内容</div>
      <div
        class="content-text"
        v-if="formInfo.sys_claim_computer"
        v-html="formInfo.sys_claim_computer"
      ></div>
      <div class="clearfix"></div>
      <span class="content-title">其他计算机终端操作系统和版本要求：</span>
      <div
        class="content-text"
        v-if="!formInfo.sys_claim_other"
      >暂无内容</div>
      <div
        class="content-text"
        v-if="formInfo.sys_claim_other"
        v-html="formInfo.sys_claim_other"
      ></div>
      <div class="clearfix"></div>
      <span class="content-title">支持移动端：</span>
      <div
        class="content-text"
        v-if="formInfo.sys_claim_mobile == 1"
      >是</div>
      <div
        class="content-text"
        v-else-if="formInfo.sys_claim_mobile == 0"
      >否</div>
      <div
        class="content-text"
        v-else
      >暂无内容</div>
    </div>
    <p class="part-title">用户非操作系统软件配置要求（兼容至少2种及以上主流浏览器）
      <a
        v-show="isShow"
        href="javascript:;"
        @click="clearItem('not_sys')"
      ><i class="icon iconfont">&#xe614;</i>清空</a>
      <a
        v-show="isShow"
        href="javascript:;"
        @click="openNotSys"
      ><i class="icon iconfont">&#xe660;</i>编辑</a>
    </p>
    <div class="part-content">
      <span class="content-title">（1）非操作系统软件要求（支持2种及以上主流浏览器）：</span>
      <div class="clearfix"></div>
      <div
        class="content-text"
        style="margin-right:10px"
        v-for="(item,index) in formInfo.not_sys_claim_soft"
        :key="index"
      >{{item}}</div>
      <div class="clearfix"></div>
      <span class="content-title">需要特定插件：</span>
      <div
        class="content-text"
        v-if="formInfo.not_sys_claim_plugin == 1"
      >是</div>
      <div
        class="content-text"
        v-else-if="formInfo.not_sys_claim_plugin == 0"
      >否</div>
      <div
        class="content-text"
        v-else
      >暂无内容</div>
      <div class="clearfix"></div>
      <span class="content-title">插件名称：</span>
      <div
        class="content-text"
        v-if="!formInfo.not_sys_claim_plugin_name"
      >暂无内容</div>
      <div
        class="content-text"
        v-if="formInfo.not_sys_claim_plugin_name"
        v-html="formInfo.not_sys_claim_plugin_name"
      ></div>
      <div class="clearfix"></div>
      <span class="content-title">插件容量：</span>
      <div
        class="content-text"
        v-if="!formInfo.not_sys_claim_plugin_size"
      >暂无内容</div>
      <div
        class="content-text"
        v-if="formInfo.not_sys_claim_plugin_size"
        v-html="formInfo.not_sys_claim_plugin_size"
      ></div>
      <div class="clearfix"></div>
      <span class="content-title">下载链接：</span>
      <div
        class="content-text"
        v-if="!formInfo.not_sys_claim_plugin_link"
      >暂无内容</div>
      <div
        class="content-text"
        v-if="formInfo.not_sys_claim_plugin_link"
        v-html="formInfo.not_sys_claim_plugin_link"
      ></div>
      <div class="clearfix"></div>
      <span class="content-title">其他计算机终端非操作系统软件配置要求<span class="fangsong">（需说明是否可提供相关软件下载）</span>：</span>
      <div
        class="content-text"
        v-if="!formInfo.not_sys_claim_content"
      >暂无内容</div>
      <div
        class="content-text"
        v-if="formInfo.not_sys_claim_content"
        v-html="formInfo.not_sys_claim_content"
      ></div>
    </div>
    <p class="part-title">用户硬件配置要求（如主频、内存、显存、存储容量等）
      <a
        v-show="isShow"
        href="javascript:;"
        @click="clearItem('hard')"
      ><i class="icon iconfont">&#xe614;</i>清空</a>
      <a
        v-show="isShow"
        href="javascript:;"
        @click="openHard"
      ><i class="icon iconfont">&#xe660;</i>编辑</a>
    </p>
    <div class="part-content"><span class="content-title">计算机硬件配置要求：</span>
      <div
        class="content-text"
        v-if="!formInfo.user_hardware_claim_computer"
      >暂无内容</div>
      <div
        class="content-text"
        v-if="formInfo.user_hardware_claim_computer"
        v-html="formInfo.user_hardware_claim_computer"
      ></div>
      <div class="clearfix"></div>
      <span class="content-title">其他计算终端硬件配置要求：</span>
      <div
        class="content-text"
        v-if="!formInfo.user_hardware_claim_other"
      >暂无内容</div>
      <div
        class="content-text"
        v-if="formInfo.user_hardware_claim_other"
        v-html="formInfo.user_hardware_claim_other"
      ></div>
    </div>
    <p class="part-title">用户特殊外置硬件要求（如可穿戴设备等）
      <a
        v-show="isShow"
        href="javascript:;"
        @click="clearItem('spec')"
      ><i class="icon iconfont">&#xe614;</i>清空</a>
      <a
        v-show="isShow"
        href="javascript:;"
        @click="openSpec"
      ><i class="icon iconfont">&#xe660;</i>编辑</a>
    </p>
    <div class="part-content"><span class="content-title">计算机特殊外置硬件要求：</span>
      <div
        class="content-text"
        v-if="!formInfo.user_special_claim_hardware"
      >暂无内容</div>
      <div
        class="content-text"
        v-if="formInfo.user_special_claim_hardware"
        v-html="formInfo.user_special_claim_hardware"
      ></div>
      <div class="clearfix"></div>
      <span class="content-title">其他计算终端特殊外置硬件要求：{{formInfo.user_special_claim_other?'有':'无'}}</span>
      <div class="clearfix"></div>
      <p class="fangsong">（如勾选“有”，请填写其他计算终端特殊外置硬件要求）</p>
      <div
        class="content-text"
        v-if="!formInfo.user_special_claim_other"
      >暂无内容</div>
      <div
        class="content-text"
        v-if="formInfo.user_special_claim_other"
        v-html="formInfo.user_special_claim_other"
      ></div>
    </div>
    <p class="part-title">网络安全（实验系统要求完成国家信息安全等级二级认证）
      <a
        v-show="isShow"
        href="javascript:;"
        @click="clearItem('net_safe')"
      ><i class="icon iconfont">&#xe614;</i>清空</a>
      <a
        v-show="isShow"
        href="javascript:;"
        @click="openNetSafe"
      ><i class="icon iconfont">&#xe660;</i>编辑</a>
    </p>
    <div class="part-content"><span class="content-title">证书编号：</span>
      <div class="content-text">{{formInfo.net_safe_claim.report_num?formInfo.net_safe_claim.report_num:'暂无内容'}}
      </div>
      <div class="clearfix"></div><span class="content-title">请附信息系统安全等级保护备案证明：</span>
      <div
        class="content-text preview"
        @click="getPreviewInfo(1,formInfo.net_safe_claim.record_name)"
      >{{formInfo.net_safe_claim.record_name?formInfo.net_safe_claim.record_name:'暂无内容'}}</div>
      <div class="clearfix"></div><span class="content-title">其他证明材料（定级报告或测评报告中申报实验系统的相关描述页面)：</span>
      <div
        class="content-text preview"
        @click="getPreviewInfo(2,formInfo.net_safe_claim.des_name)"
      >{{formInfo.net_safe_claim.des_name?formInfo.net_safe_claim.des_name:'暂无内容'}}</div>
    </div>
    <div
      class="form_overlay"
      id="network_overlay"
      :style="formatShowWindow(showWindow.net)"
    >
      <div class="form_overlay_bg"></div>
      <div class="form_panel">
        <div class="form_title">网络条件要求</div>
        <a
          href="javascript:void(0)"
          @click="showWindow.net = false"
          class="overlay-close"
        ><i class="iconfont"></i></a>
        <div class="form_content">
          <form id="networkForm">
            <div class="item">
              <span class="label"><i class="require"></i>说明客户端到服务器的带宽要求</span>
              <textarea
                v-model="formNet.net_claim_content"
                rows="5"
                class="form-control"
                placeholder=""
              ></textarea>
            </div>
            <div class="item"><span class="label">
                <label class="check-label">
                  <input
                    type="checkbox"
                    v-model="formNet.net_multi_computer"
                    @change="changeVal"
                    value="客户端/单机类型实验"
                  >客户端/单机类型实验</label>
              </span>
              <span class="red">（如果为客户端/单机类型验，不用填写能够支持的同时在线人数）</span>
            </div>
            <div class="item">
              <span class="label"><i class="require"></i>说明能够提供的并发响应数量</span>
              <input
                :disabled="formNet.net_multi_computer?true:false"
                v-model="formNet.net_claim_count"
                type="number"
                min="0"
                class="form-control"
              >
            </div>
          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            @click="showWindow.net = false"
            class="button close"
            id="network_close"
          >取消</a>
          <a
            href="javascript:;"
            @click="saveNet"
            class="button"
            id="network_submit"
          >提交</a>
        </div>
      </div>
    </div>
    <div
      class="form_overlay"
      id="pcos_overlay"
      :style="formatShowWindow(showWindow.sys)"
    >
      <div class="form_overlay_bg"></div>
      <div
        class="form_panel editor"
        style=""
      >
        <div class="form_title">用户操作系统要求（如Windows、Unix、iOS、Android等）</div>
        <a
          href="javascript:void(0)"
          @click="showWindow.sys = false"
          class="overlay-close"
        ><i class="iconfont"></i></a>
        <div
          class="form_content"
          style=""
        >
          <form
            id="pcosForm"
            style=""
          >
            <div
              class="item"
              style=""
            >
              <span class="label"><i class="require"></i>计算机操作系统和版本要求</span>
              <vue-ueditor-wrap
                style="margin-left: 140px;"
                v-model="formSys.sys_claim_computer"
                :config="editorConfig"
                editor-id="editor-demo-15"
              ></vue-ueditor-wrap>
            </div>
            <div
              class="item"
              style=""
            >
              <span class="label"><i class="require"></i>其他计算终端操作系统和版本要求</span>
              <vue-ueditor-wrap
                style="margin-left: 140px;"
                v-model="formSys.sys_claim_other"
                :config="editorConfig"
                editor-id="editor-demo-16"
              ></vue-ueditor-wrap>
            </div>
            <div class="item">
              <span class="label"><i class="require"></i>支持移动端</span>
              <select
                type="text"
                v-model="formSys.sys_claim_mobile"
                class="form-control isMobile"
              >
                <option value="1">是</option>
                <option value="0">否</option>
              </select>
            </div>
          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            @click="showWindow.sys = false"
            class="button close"
            id="pcos_close"
          >取消</a>
          <a
            href="javascript:;"
            @click="saveSys"
            class="button"
            id="pcos_submit"
          >提交</a>
        </div>
      </div>
    </div>

    <div
      class="form_overlay"
      id="card_overlay"
      :style="formatShowWindow(showWindow.not_sys)"
    >
      <div class="form_overlay_bg"></div>
      <div
        class="form_panel editor"
        style=""
      >
        <div class="form_title">用户非操作系统软件配置要求（兼容至少2种及以上主流浏览器）</div>
        <a
          href="javascript:void(0)"
          @click="showWindow.not_sys = false"
          class="overlay-close"
        ><i class="iconfont"></i></a>
        <div
          class="form_content"
          style=""
        >
          <form
            id="cardForm"
            style=""
          >
            <div class="item">
              <span class="label"><i class="require"></i>非操作系统软件要求</span>
              <div class="k-container">
                <label class="check-label">
                  <input
                    type="checkbox"
                    value="谷歌浏览器"
                    autocomplete="new-password"
                    v-model="formNotSys.not_sys_claim_soft"
                  >谷歌浏览器</label>
                <label class="check-label">
                  <input
                    type="checkbox"
                    value="IE浏览器"
                    autocomplete="new-password"
                    v-model="formNotSys.not_sys_claim_soft"
                  >IE浏览器</label>
                <label class="check-label">
                  <input
                    type="checkbox"
                    value="360浏览器"
                    autocomplete="new-password"
                    v-model="formNotSys.not_sys_claim_soft"
                  >360浏览器</label>
                <label class="check-label">
                  <input
                    type="checkbox"
                    value="火狐浏览器"
                    autocomplete="new-password"
                    v-model="formNotSys.not_sys_claim_soft"
                  >火狐浏览器</label>
                <label class="check-label">
                  <input
                    type="checkbox"
                    value="其他"
                    autocomplete="new-password"
                    v-model="formNotSys.not_sys_claim_soft"
                  >其他</label>
              </div>
            </div>
            <div class="item">
              <span class="label"><i class="require"></i>需要特定插件</span>
              <select
                v-model="formNotSys.not_sys_claim_plugin"
                type="text"
                class="form-control isNeedCard"
              >
                <option value="1">是</option>
                <option value="0">否</option>
              </select>
            </div>
            <div
              class="item cardTitle"
              :class="formNotSys.not_sys_claim_plugin == 1 ? '' : 'hide'"
            >
              <span class="label"><i class="require"></i>插件名称</span>
              <input
                v-model="formNotSys.not_sys_claim_plugin_name"
                type="text"
                class="form-control"
                maxlength="25"
              >
            </div>
            <div
              class="item cardBytes"
              :class="formNotSys.not_sys_claim_plugin == 1 ? '' : 'hide'"
            >
              <span class="label"><i class="require"></i>插件大小</span>
              <input
                v-model="formNotSys.not_sys_claim_plugin_size"
                type="text"
                class="form-control"
                maxlength="25"
              >
            </div>
            <div
              class="item cardURL"
              :class="formNotSys.not_sys_claim_plugin == 1 ? '' : 'hide'"
            >
              <span class="label"><i class="require"></i>下载链接</span>
              <input
                v-model="formNotSys.not_sys_claim_plugin_link"
                type="text"
                class="form-control"
                maxlength="25"
              >
            </div>
            <div
              class="item"
              style=""
            >
              <span class="label"><i class="require"></i>其他计算机终端非操作系统软件配置要求</span>
              <vue-ueditor-wrap
                style="margin-left: 140px;"
                v-model="formNotSys.not_sys_claim_content"
                :config="editorConfig"
                editor-id="editor-demo-17"
              ></vue-ueditor-wrap>
            </div>
          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            @click="showWindow.not_sys = false"
            class="button close"
            id="card_close"
          >取消</a>
          <a
            href="javascript:;"
            @click="saveNotSys"
            class="button"
            id="card_submit"
          >提交</a>
        </div>
      </div>
    </div>

    <div
      class="form_overlay"
      id="hardware_overlay"
      :style="formatShowWindow(showWindow.hard)"
    >
      <div class="form_overlay_bg"></div>
      <div class="form_panel">
        <div class="form_title">用户硬件配置要求（如主频、内存、显存、存储容量等）</div>
        <a
          href="javascript:void(0)"
          @click="showWindow.hard = false"
          class="overlay-close"
        ><i class="iconfont"></i></a>
        <div class="form_content">
          <form id="hardwareForm">
            <div class="item">
              <span class="label"><i class="require"></i>计算机硬件配置要求</span>
              <textarea
                v-model="formHard.user_hardware_claim_computer"
                rows="5"
                class="form-control"
                placeholder=""
              ></textarea>
            </div>
            <div class="item">
              <span class="label"><i class="require"></i>其他计算终端硬件配置要求</span>
              <textarea
                v-model="formHard.user_hardware_claim_other"
                rows="5"
                class="form-control"
                placeholder=""
              ></textarea>
            </div>
          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            @click="showWindow.hard = false"
            class="button close"
            id="hardware_close"
          >取消</a>
          <a
            href="javascript:;"
            @click="saveHard"
            class="button"
            id="hardware_submit"
          >提交</a>
        </div>
      </div>
    </div>

    <div
      class="form_overlay"
      id="specialHW_overlay"
      :style="formatShowWindow(showWindow.spec)"
    >
      <div class="form_overlay_bg"></div>
      <div class="form_panel">
        <div class="form_title">用户特殊外置硬件配置要求（如可穿戴设备等）</div>
        <a
          href="javascript:void(0)"
          @click="showWindow.spec = false"
          class="overlay-close"
        ><i class="iconfont"></i></a>
        <div class="form_content">
          <form id="specialHWForm">
            <div class="item">
              <span class="label"><i class="require"></i>特殊外置硬件</span>
              <textarea
                v-model="formSpec.user_special_claim_hardware"
                rows="5"
                class="form-control"
                placeholder=""
              ></textarea>
            </div>
            <div class="item">
              <span class="label"><i class="require"></i>其他计算终端特殊外置硬件要求</span>
              <select
                id=""
                v-model="formSpec.user_special_claim_has_other"
              >
                <option value="">请选择</option>
                <option :value="1">有</option>
                <option :value="0">无</option>
              </select>
            </div>
            <div
              class="item"
              v-if="formSpec.user_special_claim_has_other"
            >
              <span class="label"><i class="require"></i></span>
              <textarea
                v-model="formSpec.user_special_claim_other"
                rows="5"
                class="form-control"
                placeholder=""
              ></textarea>
            </div>
          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            @click="showWindow.spec = false"
            class="button close"
            id="specialHW_close"
          >取消</a>
          <a
            href="javascript:;"
            @click="saveSpec"
            class="button"
            id="specialHW_submit"
          >提交</a>
        </div>
      </div>
    </div>

    <div
      class="form_overlay"
      :style="formatShowWindow(showWindow.net_safe)"
    >
      <div class="form_overlay_bg"></div>
      <div class="form_panel">
        <div class="form_title">网络安全（实验系统要求完成国家信息安全等级二级认证）</div>
        <a
          href="javascript:void(0)"
          @click="showWindow.net_safe = false"
          class="overlay-close"
        ><i class="iconfont"></i></a>
        <div class="form_content">
          <form id="safeForm">
            <div class="item">
              <span class="label"><i class="require"></i>证书编号</span>
              <input
                type="text"
                class="form-control"
                autocomplete="new-password"
                v-model="formNetSafe.report_num"
                maxlength="25"
              >
            </div>
            <div class="item ceprove">
              <span class="label"><i class="require"></i>请附信息系统安全等级保护备案证明</span>
              <div class="item-box clearfix">
                <div
                  class="ceprove-list"
                  v-if="formNetSafe.record_name"
                >
                  <p>
                    <a>{{formNetSafe.record_name}}</a>
                    <span
                      class="del"
                      @click="delRecord"
                    >
                      x
                    </span>
                  </p>
                </div>
                <span
                  class="button"
                  @click="showFileWindow(1)"
                >上传</span>
              </div>
            </div>
            <div class="item ceother">
              <span class="label"><i class="require"></i>其他证明材料（定级报告或测评报告中申报实验系统的相关描述页面)</span>
              <div class="item-box clearfix">
                <div
                  class="ceother-list"
                  v-if="formNetSafe.des_name"
                >
                  <p>
                    <a>{{formNetSafe.des_name}}</a>
                    <span
                      class="del"
                      @click="delDes"
                    >
                      x
                    </span>
                  </p>
                </div>
                <span
                  class="button"
                  @click="showFileWindow(2)"
                >上传</span>
              </div>
            </div>
          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            @click="showWindow.net_safe = false"
            class="button close"
            id="domainURL_close"
          >取消</a>
          <a
            href="javascript:;"
            @click="saveNetSafe"
            class="button"
            id="domainURL_submit"
          >提交</a>
        </div>
      </div>
    </div>
    <div
      id="file-upload-overlay"
      :style="showWindow.bigFile ? 'display: block' : ''"
    >
      <div class="file-upload-bg"></div>
      <div class="file-upload">
        <div
          class="file-upload-type"
          v-show="toggleUpload==1"
        >允许上传的文件扩展名：jpg,png</div>
        <div
          class="file-upload-type"
          v-show="toggleUpload==2"
        >允许上传的文件扩展名：jpg,png,pdf</div>
        <div
          class="file-upload-close"
          @click="hideFileWindow"
        >×</div>
        <span
          class="file_uploadBtn"
          id="file_uploadBtn"
          style="display: block;"
        >
          选择文件<input
            type="file"
            id="file_fileInput"
            :accept="toggleUpload == 1 ? '.jpg,.png' : '.jpg,.png,.pdf'"
            ref="docFile"
            style="display: block;"
            @change="fileChange"
          >
        </span>
        <div
          class="fileBox"
          id="file_uploadBox"
          style="display: block;"
        >
          <span
            class="pauseBtn"
            id="file_pauseBtn"
            style="display: none;"
          >暂停</span>
          <span
            class="goBtn"
            id="file_goBtn"
            style="display:none;"
          >继续</span>
          <div
            class="filename"
            id="file_filename"
            style="display: none;"
          ></div>
          <div
            class="pbar"
            :style="showWindow.bigFileOption.showProgress ? 'display: block' : 'display: none'"
          >
            <div
              class="progress"
              id="file_progress"
              :style="'width: ' + Math.ceil(showWindow.bigFileOption.progressValue * 4.2) + 'px;'"
            ></div>
            <div id="file_percent">{{ showWindow.bigFileOption.progressValue }}%</div>
          </div>
        </div>
        <div class="clear"></div>
      </div>
    </div>
    <div
      id="res-preview-overlay"
      :style="formatShowWindow(showWindow.preview)"
    >
      <div id="res-preview-overlay-bg"></div>
      <div id="res-preview-panel">
        <div id="res-preview-title">{{previewInfo.title_name}}
          <div
            id="res-preview-close"
            @click="showWindow.preview = false"
          >x</div>
        </div>
        <div id="res-preview-content">
          <div
            class="pdf-region"
            v-if="previewInfo.previewType"
          >
            <pdf
              :page="pageNum"
              :src="previewInfo.previewPath"
              @progress="loadedRatio = $event"
              @num-pages="pageTotalNum=$event"
            ></pdf>
            <div class="pagecolor">
              <span @click="prePage">上一页 </span> {{ pageNum }} / {{ pageTotalNum }} <span @click="nextPage"> 下一页</span>
            </div>
          </div>

          <div
            class="img-region"
            v-else
          >
            <img
              :src="previewInfo.previewPath"
              alt=""
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueUeditorWrap from 'vue-ueditor-wrap'
import pdf from 'vue-pdf'
export default {
  name: 'ExperimentMaintainNet',
  components: {
    pdf,
    VueUeditorWrap
  },
  props: ['isShow', 'expId'],
  data() {
    return {
      pageNum: 1,
      pageTotalNum: 1,
      loadedRatio: 0,
      editorConfig: {
        UEDITOR_HOME_URL: '/UE/',
        serverUrl: this.$store.state.uEditorServerUrl,
        autoHeight: true,
        initialFrameWidth: '100%',
        initialFrameHeight: 300
      },
      showWindow: {
        net: false,
        sys: false,
        not_sys: false,
        hard: false,
        spec: false,
        net_safe: false,
        bigFile: false,
        bigFileOption: {
          showProgress: false,
          progressValue: 0
        },
        preview: false
      },
      previewInfo: {
        previewType: '',
        title_name: '',
        previewPath: '',
        excelData: null
      },
      formInfo: {
        net_claim_content: '',
        net_multi_computer: false,
        net_claim_count: '',

        sys_claim_computer: '',
        sys_claim_other: '',
        sys_claim_mobile: '',

        not_sys_claim_soft: [],
        not_sys_claim_plugin: '',
        not_sys_claim_plugin_name: '',
        not_sys_claim_plugin_size: '',
        not_sys_claim_plugin_link: '',
        not_sys_claim_content: '',

        user_hardware_claim_computer: '',
        user_hardware_claim_other: '',

        user_special_claim_hardware: '',
        user_special_claim_other: '',

        net_safe_claim: ''
      },
      formNet: {
        net_claim_content: '',
        net_multi_computer: false,
        net_claim_count: ''
      },
      formSys: {
        sys_claim_computer: '',
        sys_claim_other: '',
        sys_claim_mobile: ''
      },
      formNotSys: {
        not_sys_claim_soft: [],
        not_sys_claim_plugin: '',
        not_sys_claim_plugin_name: '',
        not_sys_claim_plugin_size: '',
        not_sys_claim_plugin_link: '',
        not_sys_claim_content: ''
      },
      formHard: {
        user_hardware_claim_computer: '',
        user_hardware_claim_other: ''
      },
      formSpec: {
        user_special_claim_hardware: '',
        user_special_claim_has_other: '',
        user_special_claim_other: ''
      },
      formNetSafe: {
        report_num: '',
        record_path: '',
        record_name: '',
        des_path: '',
        des_name: ''
      },
      toggleUpload: 1,
      sensitiveWord: []
    }
  },
  methods: {
    // 上一页
    prePage() {
      let page = this.pageNum
      page = page > 1 ? page - 1 : this.pageTotalNum
      this.pageNum = page
    },
    // 下一页
    nextPage() {
      let page = this.pageNum
      page = page < this.pageTotalNum ? page + 1 : 1
      this.pageNum = page
    },
    delDes() {
      this.formNetSafe.des_name = ''
      this.formNetSafe.des_path = ''
    },
    delRecord() {
      this.formNetSafe.record_name = ''
      this.formNetSafe.record_path = ''
    },
    getPreviewInfo(num, val) {
      var arr
      if (val) {
        arr = val.slice(-3, val.length)
        this.previewInfo.previewType = arr === 'pdf'
        this.showWindow.preview = true
      }

      if (num === 1) {
        if (this.formInfo.net_safe_claim.record_name) {
          this.previewInfo.title_name = this.formInfo.net_safe_claim.record_name
          this.previewInfo.previewPath = this.formInfo.net_safe_claim.record_path
          this.showWindow.preview = true
        } else {
          this.showWindow.preview = false
        }
      } else {
        if (this.formInfo.net_safe_claim.des_name) {
          this.previewInfo.title_name = this.formInfo.net_safe_claim.des_name
          this.previewInfo.previewPath = this.formInfo.net_safe_claim.des_path
          this.showWindow.preview = true
        } else {
          this.showWindow.preview = false
        }
      }
    },
    async getInfo() {
      const url = '/allowany/experiment/' + this.expId + '/'
      await this.$http.get(url).then(async (data) => {
        this.formInfo = data
        this.formInfo.not_sys_claim_soft = data.not_sys_claim_soft ? JSON.parse(data.not_sys_claim_soft) : ''
        this.formInfo.net_safe_claim = data.net_safe_claim ? JSON.parse(data.net_safe_claim) : ''
      }).catch((error) => {
        console.log(error)
      })
    },
    showFileWindow(val) {
      if (this.isShow) {
        this.toggleUpload = val
        this.showWindow.bigFile = true
      }
    },
    hideFileWindow() {
      this.showWindow.bigFile = false
    },
    async fileChange() {
      if (this.$store.state.max_file_size && this.$refs.docFile.files[0].size > this.$store.state.max_file_size) {
        alert('文件大小超过限制！')
        return false
      }
      this.showWindow.bigFileOption.showProgress = true
      const fileRealName = this.$refs.docFile.files[0].name
      const uploadUrl = '/info_files/' + fileRealName
      await this.$http.put(uploadUrl, this.$refs.docFile.files[0], {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: (e) => {
          this.showWindow.bigFileOption.progressValue = Math.ceil(e.loaded / e.total * 100)
        }
      }).then((data) => {
        if (this.toggleUpload === 1) {
          this.formNetSafe.record_name = fileRealName
          this.formNetSafe.record_path = data
        } else {
          this.formNetSafe.des_name = fileRealName
          this.formNetSafe.des_path = data
        }
        this.showWindow.bigFileOption.showProgress = false
        this.showWindow.bigFileOption.progressValue = 0
        this.hideFileWindow()
      }).catch((error) => {
        console.log(error)
        this.showWindow.bigFileOption.showProgress = false
        this.showWindow.bigFileOption.progressValue = 0
        this.hideFileWindow()
        this.$layer.msg('上传失败！')
      })
    },
    /**
     * 根据字段打开/关闭相应的弹窗
     */
    formatShowWindow(tag) {
      if (tag) {
        return {
          visibility: 'visible'
        }
      } else {
        return {}
      }
    },

    /**
     * 打开网络条件要求弹窗
     */
    openNet() {
      this.formNet.net_multi_computer = this.formInfo.net_multi_computer
      this.formNet.net_claim_content = this.formInfo.net_claim_content
      this.formNet.net_claim_count = this.formInfo.net_claim_count
      this.showWindow.net = true
    },
    /**
     * 打开用户操作系统要求弹窗
     */
    openSys() {
      this.formSys.sys_claim_computer = this.formInfo.sys_claim_computer
      this.formSys.sys_claim_other = this.formInfo.sys_claim_other
      this.formSys.sys_claim_mobile = this.formInfo.sys_claim_mobile
      this.showWindow.sys = true
    },
    /**
     * 打开用户非操作系统软件配置要求弹窗
     */
    openNotSys() {
      this.formNotSys.not_sys_claim_soft = [...this.formInfo.not_sys_claim_soft]
      this.formNotSys.not_sys_claim_plugin = this.formInfo.not_sys_claim_plugin
      this.formNotSys.not_sys_claim_plugin_name = this.formInfo.not_sys_claim_plugin_name
      this.formNotSys.not_sys_claim_plugin_size = this.formInfo.not_sys_claim_plugin_size
      this.formNotSys.not_sys_claim_plugin_link = this.formInfo.not_sys_claim_plugin_link
      this.formNotSys.not_sys_claim_content = this.formInfo.not_sys_claim_content
      this.showWindow.not_sys = true
    },
    /**
     * 打开用户硬件配置要求弹窗
     */
    openHard() {
      this.formHard.user_hardware_claim_computer = this.formInfo.user_hardware_claim_computer
      this.formHard.user_hardware_claim_other = this.formInfo.user_hardware_claim_other
      this.showWindow.hard = true
    },
    /**
     * 打开用户特殊外置硬件要求弹窗
     */
    openSpec() {
      this.formSpec.user_special_claim_has_other = this.formInfo.user_special_claim_has_other
      this.formSpec.user_special_claim_hardware = this.formInfo.user_special_claim_hardware
      this.formSpec.user_special_claim_other = this.formInfo.user_special_claim_other
      this.showWindow.spec = true
    },
    /**
     * 打开网络安全弹窗
     */
    openNetSafe() {
      this.formNetSafe = {
        report_num: this.formInfo.net_safe_claim.report_num ? this.formInfo.net_safe_claim.report_num : '',
        record_path: this.formInfo.net_safe_claim.record_path ? this.formInfo.net_safe_claim.record_path : '',
        record_name: this.formInfo.net_safe_claim.record_name ? this.formInfo.net_safe_claim.record_name : '',
        des_path: this.formInfo.net_safe_claim.des_path ? this.formInfo.net_safe_claim.des_path : '',
        des_name: this.formInfo.net_safe_claim.des_name ? this.formInfo.net_safe_claim.des_name : ''
      }
      this.showWindow.net_safe = true
    },
    changeVal(e) {
      if (this.formNet.net_multi_computer) {
        this.formNet.net_claim_count = ''
        this.formNet.net_claim_count = e.target.value
      }
    },
    /**
     * 保存网络条件要求
     */
    async saveNet() {
      if (!this.formNet.net_multi_computer && this.formNet.net_claim_count === '客户端/单机类型实验') {
        this.$layer.msg('请正确填写能够支持的同时在线人数')
        return false
      }
      const url = '/experiment/' + this.expId + '/'
      this.formNet.net_multi_computer = this.formNet.net_multi_computer ? 1 : 0
      await this.$http.put(url, this.formNet).then((data) => {
        if (data.id) {
          this.formInfo.net_multi_computer = this.formNet.net_multi_computer
          this.formInfo.net_claim_content = this.formNet.net_claim_content
          this.formInfo.net_claim_count = this.formNet.net_claim_count
          this.showWindow.net = false
        } else {
          this.$layer.msg('修改失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('修改失败！')
      })
    },
    async saveSys() {
      const url = '/experiment/' + this.expId + '/'
      const computer = this.utils.getWords(this.formSys.sys_claim_computer, this.sensitiveWord)
      const other = this.utils.getWords(this.formSys.sys_claim_other, this.sensitiveWord)
      if (computer) {
        this.$layer.msg('输入的内容有敏感词!')
        return false
      }
      if (other) {
        this.$layer.msg('输入的内容有敏感词!')
        return false
      }
      await this.$http.put(url, this.formSys).then((data) => {
        if (data.id) {
          this.formInfo.sys_claim_computer = this.formSys.sys_claim_computer
          this.formInfo.sys_claim_other = this.formSys.sys_claim_other
          this.formInfo.sys_claim_mobile = this.formSys.sys_claim_mobile
          this.showWindow.sys = false
        } else {
          this.$layer.msg('修改失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('修改失败！')
      })
    },
    async saveNotSys() {
      if (Number(this.formNotSys.not_sys_claim_plugin) === 0) {
        this.formNotSys.not_sys_claim_plugin_name = ''
        this.formNotSys.not_sys_claim_plugin_size = ''
        this.formNotSys.not_sys_claim_plugin_link = ''
      }
      const isRight = this.utils.getWords(this.formNotSys.not_sys_claim_content, this.sensitiveWord)
      if (isRight) {
        this.$layer.msg('输入的内容有敏感词!')
        return false
      }
      this.formNotSys.not_sys_claim_soft = JSON.stringify(this.formNotSys.not_sys_claim_soft)
      const url = '/experiment/' + this.expId + '/'
      await this.$http.put(url, this.formNotSys).then((data) => {
        if (data.id) {
          this.formInfo.not_sys_claim_soft = [...JSON.parse(this.formNotSys.not_sys_claim_soft)]
          this.formInfo.not_sys_claim_plugin = this.formNotSys.not_sys_claim_plugin
          this.formInfo.not_sys_claim_plugin_name = this.formNotSys.not_sys_claim_plugin_name
          this.formInfo.not_sys_claim_plugin_size = this.formNotSys.not_sys_claim_plugin_size
          this.formInfo.not_sys_claim_plugin_link = this.formNotSys.not_sys_claim_plugin_link
          this.formInfo.not_sys_claim_content = this.formNotSys.not_sys_claim_content
          this.showWindow.not_sys = false
        } else {
          this.$layer.msg('修改失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('修改失败！')
      })
    },
    async saveHard() {
      const url = '/experiment/' + this.expId + '/'
      await this.$http.put(url, this.formHard).then((data) => {
        if (data.id) {
          this.formInfo.user_hardware_claim_computer = this.formHard.user_hardware_claim_computer
          this.formInfo.user_hardware_claim_other = this.formHard.user_hardware_claim_other
          this.showWindow.hard = false
        } else {
          this.$layer.msg('修改失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('修改失败！')
      })
    },
    async saveSpec() {
      if (this.formSpec.user_special_claim_has_other === '') {
        this.$layer.msg('请选择其他计算终端特殊外置硬件要求')
        return
      }
      if (Number(this.formSpec.user_special_claim_has_other) === 1 && !this.formSpec.user_special_claim_other) {
        this.$layer.msg('请填写其他计算终端特殊外置硬件要求')
        return
      }
      if (this.formSpec.user_special_claim_has_other !== 1) {
        this.formSpec.user_special_claim_other = ''
      }
      const url = '/experiment/' + this.expId + '/'
      await this.$http.put(url, this.formSpec).then((data) => {
        if (data.id) {
          this.formInfo.user_special_claim_hardware = this.formSpec.user_special_claim_hardware
          this.formInfo.user_special_claim_other = this.formSpec.user_special_claim_other
          this.showWindow.spec = false
          this.getInfo()
        } else {
          this.$layer.msg('修改失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('修改失败！')
      })
    },
    async saveNetSafe() {
      const params = {
        net_safe_claim: JSON.stringify(this.formNetSafe)
      }
      const url = '/experiment/' + this.expId + '/'
      await this.$http.put(url, params).then((data) => {
        if (data.id) {
          this.formInfo.net_safe_claim = { ...this.formNetSafe }
          this.showWindow.net_safe = false
        } else {
          this.$layer.msg('修改失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('修改失败！')
      })
    },

    /**
     * 清空对应模块的数据
     */
    clearItem(categgory) {
      switch (categgory) {
        case 'net':
          this.formNet = {
            net_multi_computer: 0,
            net_claim_content: '',
            net_claim_count: ''
          }
          this.saveNet()
          break
        case 'sys':
          this.formSys = {
            sys_claim_computer: '',
            sys_claim_other: '',
            sys_claim_mobile: 0
          }
          this.saveSys()
          break
        case 'not_sys':
          this.formNotSys = {
            not_sys_claim_soft: [],
            not_sys_claim_plugin: 0,
            not_sys_claim_plugin_name: '',
            not_sys_claim_plugin_size: '',
            not_sys_claim_plugin_link: '',
            not_sys_claim_content: ''
          }
          this.saveNotSys()
          break
        case 'hard':
          this.formHard = {
            user_hardware_claim_computer: '',
            user_hardware_claim_other: ''
          }
          this.saveHard()
          break
        case 'spec':
          this.formSpec = {
            user_special_claim_hardware: '',
            user_special_claim_other: ''
          }
          this.saveSpec()
          break
        case 'net_safe':
          this.formNetSafe = {
            net_safe_claim: null
          }
          this.saveNetSafe()
          break
      }
    },
    // 获取敏感词
    async getSensitiveWord() {
      await this.$http.get('/sensitiveword/', {
        params: {
          page: 1,
          size: 10000,
          status: 1
        }
      }).then((data) => {
        if (data.results.length) {
          data.results.forEach(item => {
            if (item.words) {
              const wordList = item.words.split('\n')
              for (let i = 0; i < wordList.length; i++) {
                this.sensitiveWord.push(wordList[i])
              }
            }
          })
        } else {
          this.sensitiveWord = []
        }
      }).catch((error) => {
        console.log(error)
      })
    }
  },
  async mounted() {
    await this.getInfo()
    this.getSensitiveWord()
  }
}
</script>

<style scoped src="../../../../assets/css/project-detail.css"></style>
<style scoped src="../../../../assets/css/table.css"></style>
<style scoped src="../../../../assets/css/chunkUpload.css"></style>
<style scoped src="../../../../assets/css/project-manage.css"></style>
<style scoped src="../../../../assets/css/project-infor-2020.css"></style>

<style lang="less" scoped>
.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
  vertical-align: baseline;
}
.content .container {
  width: 1200px;
  margin: 0 auto;
  visibility: visible;
}

.center_content {
  .box-wrap {
    margin-top: 20px;
    padding: 40px;
    background: #fff;
    box-sizing: border-box;
  }

  .title {
    height: 50px;
    line-height: 50px;
    font-size: 20px;
    font-weight: bold;
    border-bottom: 1px solid #eee;
    position: relative;
    padding-right: 160px;
    padding-left: 20px;

    .title-btns {
      position: absolute;
      top: 0;
      right: 0;

      > a {
        margin-right: 10px;
        font-size: 14px;
        font-weight: lighter;
        color: #3399ff;
        cursor: pointer;

        i {
          font-size: 14px;
          margin-right: 5px;
        }
      }
    }
  }

  .title:before {
    content: "";
    width: 4px;
    height: 1em;
    background-color: #73D6CA;
    position: absolute;
    left: 0;
    top: 16px;
  }

  .mbox .lBox {
    float: left;
    width: 600px;

    .detail-base {
      font-size: 16px;
      padding: 20px 0;
      height: 376px;
      box-sizing: border-box;
      overflow-y: auto;

      .detail-item {
        display: inline-block;
        margin-right: 30px;
        padding: 10px 0;
      }

      .detail-intro {
        padding: 10px 0;

        .label {
          float: left;
        }

        p {
          padding-left: 80px;
        }
      }

      .clearfix:after {
        content: ".";
        display: block;
        height: 0;
        clear: both;
        visibility: hidden;
        overflow: hidden;
      }
    }
  }

  .label {
    width: 130px;
    padding-right: 10px;
  }

  .mbox .rBox {
    float: right;
    width: 460px;

    .preview {
      padding: 6px 20px;
      border: 1px solid #4976e8;
      color: #4976e8;
      border-radius: 3px;
    }

    .submit {
      padding: 7px 20px;
      background: #4976e8;
      color: #fff;
      border-radius: 3px;
    }

    .imgCover {
      width: 100%;
      height: 306px;
      margin-top: 10px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .upload {
      width: 140px;
      height: 40px;
      line-height: 40px;
      display: block;
      margin: 10px auto;
      text-align: center;
      background: #21b295;
      color: #fff;
      border-radius: 3px;
      cursor: pointer;
      font-size: 16px;
    }
  }
  .part-content {
    .part-new-table {
      margin: 10px 0;
      border: 1px solid #ebebeb;
      width: 100%;
      max-width: 100%;
      border-spacing: 0;
      border-collapse: collapse;
      background-color: transparent;
      tr th {
        background-color: #f8faff;
        color: #999;
        font-weight: normal;
      }
    }
    .part-new-table tr th,
    .part-new-table tr td {
      padding: 8px;
      line-height: 1.42857143;
      vertical-align: middle;
      border: 1px solid #ebebeb;
      text-align: center;
    }
  }
  .item-box {
    float: left;
    width: 302px;
    position: relative;
  }

  .uploadImgPreview li img {
    width: 100%;
    margin-top: 5px;
  }

  .clearfix:after {
    content: ".";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
    overflow: hidden;
  }

  .video-box {
    .lBox {
      float: left;
      width: 500px;

      .upload {
        padding: 6px 20px;
        background: #73D6CA;
        color: #fff;
        border-radius: 3px;
      }
    }

    .video-wrap {
      width: 400px;
      height: 226px;
      margin: 10px auto 0;
      background: #000;

      video {
        width: 100%;
        height: 100%;
      }
    }

    .rBox {
      float: right;
      width: 500px;

      .upload {
        padding: 6px 20px;
        background: #73D6CA;
        color: #fff;
        border-radius: 3px;
      }
    }
  }

  .menu-box {
    overflow: hidden;
    border-bottom: 1px solid #eee;

    ul {
      li {
        text-align: center;
        float: left;
        margin-right: 10px;

        a {
          display: block;
          padding: 10px;
          font-size: 16px;
          color: #002900;
          text-decoration: none;
          border-bottom: 3px solid #fff;
        }

        &:hover a {
          color: #73D6CA;
          border-color: #73D6CA;
        }
      }

      .onActive {
        a {
          color: #73D6CA;
          border-color: #73D6CA;
        }
      }
    }
  }

  .part {
    min-height: 390px;
    margin-top: 30px;
  }
}
.form_contentEdit .label {
  width: 100px !important;
}
.form_content .k-container {
  max-width: 640px;
  width: 640px;
  .item-table {
    width: 640px;
    input {
      width: 100%;
      border: none;
    }
  }
  .item-table th,
  .item-table td {
    border-bottom: 1px solid #ddd;
    border-right: 1px solid #ddd;
    text-align: center;
    padding-bottom: 1px;
  }
}
.teachItem {
  p {
    font-weight: 600;
  }
  .link {
    color: #0b80ff;
    margin: 10px 0;
    display: block;
  }
}
.teachEdit {
  .m-r {
    color: #333333;
    font-weight: 500;
    display: inline-block;
    width: 150px;
    input {
      position: relative;
      top: -1px;
      margin-right: 7px;
    }
  }
  .file {
    color: #0b80ff;
    display: block;
    .del {
      margin-left: 10px;
      font-size: 22px;
      color: #c7254e;
      cursor: pointer;
      margin: 0;
      background: transparent;
      top: 3px;
      position: relative;
    }
  }
  .upload {
    display: block;
    text-align: center;
    width: 55px;
    line-height: 30px;
    background: #f19830;
    color: #fff;
    cursor: pointer;
  }
}
.warn {
  p {
    font-size: 12px;
    color: #df3d3e;
  }
  span {
    font-size: 12px;
    color: #337ab7;
    cursor: pointer;
  }
}
.NumCount {
  display: inline-block;
  text-align: center;
  width: 40px;
  border-bottom: 1px solid #999;
}
.teach_Item {
  color: #666;
  .text {
    width: 40px !important;
    height: 20px !important ;
    line-height: 23px !important;
    border: none !important;
    text-align: center;
    border-bottom: 1px solid #999 !important;
  }
}
.form_overlay {
  z-index: 100 !important;
}

.file-upload {
  z-index: 200 !important;
}

.menu-list > li.on a,
.menu-list > li:hover a {
  color: #73D6CA !important;
  border-color: #73D6CA !important;
}
.signPic {
  max-height: 20px;
  max-width: 120px;
  vertical-align: middle;
  display: inline-block;
  margin-top: -3px;
  margin-right: 25px;
}
.del-icon {
  color: #ff0000;
  position: relative;
  display: inline-block;
  border: 1px solid #ddd;
  font-size: 12px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  border-radius: 20px;
  right: 17px;
  top: -12px;
  cursor: pointer;
}
.url_link {
  flex: 1;
  overflow-x: auto;
  white-space: nowrap;
}
.url_link::-webkit-scrollbar {
  display: none;
}
.form_control {
  text-align: center;
}
.form_control a {
  float: none;
  display: inline-block;
}
.addOtherUser {
  display: inline-block;
  color: #ffffff;
  margin-left: 15px;
  height: 34px;
  line-height: 34px;
  padding: 0 15px;
  border-radius: 4px;
  background-color: #028c8c;
  border-color: #028c8c;
  cursor: pointer;
}
.infor span {
  font-size: 14px;
  color: #333;
  margin-right: 20px;
  display: inline-block;
  margin-bottom: 10px;
  display: inline-block;
}
.infor span i {
  color: #999;
}
.person {
  position: relative;
  overflow: hidden;
}
.person_symbol {
  position: absolute;
  left: -20px;
  top: 4px;
  background: #ff2424;
  color: #fff;
  width: 70px;
  text-align: center;
  font-size: 12px;
  transform: rotate(-45deg);
  -ms-transform: rotate(-45deg); /* Internet Explorer 9*/
  -moz-transform: rotate(-45deg); /* Firefox */
  -webkit-transform: rotate(-45deg); /* Safari 和 Chrome */
  -o-transform: rotate(-45deg); /* Opera */
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);
}
.tips {
  margin-bottom: 10px;
  color: rgb(144, 144, 144);
}
.content_underline {
  text-decoration: underline;
  margin: 0 10px;
}
.content-text-change {
  float: unset;
}

.form_content .imgMsg {
  padding-left: 110px;
}
.form_content .k-container .step-box .item-table {
  width: 100%;
  margin-bottom: 20px;
}
.form_content .item .step-box input[type="radio"],
.form_content .item .step-box input[type="checkbox"] {
  margin-right: 10px;
  margin-top: -2px !important;
}
.form_content .k-container .item-table .check-label input {
  width: unset;
}
.form_content .subject-wrap {
  width: unset;
  max-width: unset;
}
.form_content .red {
  color: red;
  font-size: 13px;
}
/deep/#res-preview-overlay {
  visibility: hidden;
}
#res-preview-close {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid red;
  text-align: center;
  line-height: 20px;
}
.pdf-region {
  max-height: 560px;
  overflow-y: scroll;
}
.preview {
  color: #4976e8;
  cursor: pointer;
}
.img-region {
  max-width: 950px;
}
.img-region img {
  display: table;
  width: 100%;
  border: none;
  margin: 0 auto;
}
#res-preview-content {
  overflow-y: auto;
}
</style>
